import { render, staticRenderFns } from "./BoxEndereco.vue?vue&type=template&id=69fd1cf4&"
import script from "./BoxEndereco.vue?vue&type=script&lang=js&"
export * from "./BoxEndereco.vue?vue&type=script&lang=js&"
import style0 from "./BoxEndereco.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports